import { render, staticRenderFns } from "./partner-index.vue?vue&type=template&id=2b901fd1&scoped=true&lang=pug&"
import script from "./partner-index.vue?vue&type=script&lang=js&"
export * from "./partner-index.vue?vue&type=script&lang=js&"
import style0 from "./partner-index.vue?vue&type=style&index=0&id=2b901fd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b901fd1",
  null
  
)

export default component.exports